import Icon from '../Icon.vue'

Icon.register({
  'external_link': {
    width: 14,
    height: 14,
    paths: [
      {
        d: 'M14 1.54v11.062C14 13.3 13.3 14 12.46 14H1.54C.7 14 0 13.3 0 12.46V1.54C0 .7.7 0 1.54 0h11.062C13.3 0 14 .7 14 1.54zm-2.8.42H7.7c-.56 0-.981.84-.419 1.259l.98.98-6.16 6.16a.428.428 0 000 .563l.977.976c.14.141.422.141.563 0l6.16-6.16.98.98c.418.563 1.258.141 1.258-.417V2.8c0-.422-.418-.84-.84-.84z'
      }
    ]
  }
})
